module.exports = __webpack_public_path__ + "static/media/LogoSmall.3e181607.png";